import { SEMESTER_MONTHS } from "../constants";

export const getMaxPoints = (gradeLevel, month) => {
	const isLastMonth = [5, 12].includes(month);

	if (gradeLevel <= 3) {
		return 25;
	} else {
		return isLastMonth ? 40 : 20;
	}
};

export const getSemesterMonths = (semester) => {
	return SEMESTER_MONTHS[semester] || [];
};

export const calculateSemesterTotal = (grades, studentId, semester) => {
	if (!grades[studentId]) return 0;
	const semesterMonths = getSemesterMonths(semester);
	return semesterMonths.reduce((total, month) => {
		const monthGrade = grades[studentId]?.[month.id];
		return total + (monthGrade?.total || 0);
	}, 0);
};

export const calculateSubjectTotal = (grades, subjectKey, semester) => {
	const subjectData = grades[subjectKey];
	if (!subjectData || !subjectData.months) return 0;

	const semesterMonths = getSemesterMonths(semester);
	return semesterMonths.reduce((total, month) => {
		const monthGrade = subjectData.months[month.id];
		return total + (monthGrade?.total || 0);
	}, 0);
};

export const filterBySearchTerm = (items, searchTerm, fields) => {
	const lowerSearchTerm = searchTerm.toLowerCase();
	return items.filter((item) =>
		fields.some((field) => item[field]?.toLowerCase().includes(lowerSearchTerm))
	);
};
